import FlopyModflowPackage from './FlopyModflowPackage';

export default class FlopyModflowSolverPackage<T> extends FlopyModflowPackage<T> {
}
